"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffersContainer = OffersContainer;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const offer_filter_context_1 = require("./offer-filter-context");
const Offers_1 = require("./Offers");
function OffersContainer() {
    const { value: OffersFilterValue, OffersFilterContextProvider } = (0, offer_filter_context_1.useOffersFilterContextProvider)();
    return ((0, jsx_runtime_1.jsx)(OffersFilterContextProvider, { value: OffersFilterValue, children: (0, jsx_runtime_1.jsx)(Offers_1.Offers, {}) }));
}
